import { render } from "./JobPostsDistributionChart.vue?vue&type=template&id=3f4f1bbf&scoped=true"
import script from "./JobPostsDistributionChart.vue?vue&type=script&lang=js"
export * from "./JobPostsDistributionChart.vue?vue&type=script&lang=js"

import "./JobPostsDistributionChart.vue?vue&type=style&index=0&id=3f4f1bbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4f1bbf"]])

export default __exports__